module.exports = __webpack_public_path__ + "img/IT0003124323133.818e5d6b.png";